var prices = [];
var departureMinPrices = [];
var returnMinPrices = [];
var depMinMaxPrice=[];
var retMinMaxPrice=[];


var requestParams = {
	searchMinDate: null,
	searchMaxDate: null,
    fromAirportId: null,
    toAirportId: null,
    departureStart: null,
    departureEnd: null,
    returnStart: null,
    returnEnd: null,
    isRoundTrip : false
}

function getSearchMinPriceData(dpInstant) {

	var isDepartureInstant = dpInstant.id == 'departureDate';

    var isRoundTrip = true;
    var attr = $(".returnDate").attr('disabled');

    if (typeof attr !== typeof undefined && attr !== false) {
        isRoundTrip = attr != 'disabled';
    }

    if (!isDepartureInstant && !isRoundTrip){ // will not request iff return date is empty
    	return;
	}

	var fromAirportId = $("[name=fromAirportId]").val();
	var toAirportId = $("[name=toAirportId]").val();

	var baseDate = new Date(dpInstant.drawYear, dpInstant.drawMonth, 1)
	var dateFormat = 'dd.mm.yy';
	var now = new Date();

	var start = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
	var end = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);

    start = now.getTime() > start.getTime() ? now : start;

	if (validateAndSetupParameters(start, end, fromAirportId, toAirportId, isDepartureInstant, isRoundTrip)) {

        var departureStart = $.datepicker.formatDate(dateFormat, requestParams.departureStart);;
		var departureEnd = $.datepicker.formatDate(dateFormat, requestParams.departureEnd);;
		var returnStart = $.datepicker.formatDate(dateFormat, requestParams.returnStart);;
		var returnEnd = $.datepicker.formatDate(dateFormat, requestParams.returnEnd);;

		$.ajax(
			{
				type : 'POST',
				url : '/getSearchMinPriceDataList',
				dataType : 'json',
				async:true,
				data : {
                    departureStart : departureStart,
                    departureEnd : departureEnd,
                    returnStart : returnStart,
                    returnEnd : returnEnd,
                    fromAirportId: fromAirportId,
					toAirportId : toAirportId
				},
				success : function(response) {
					if(response.success) {
						departureMinPrices = departureMinPrices
								.concat(response.departureMinPrices
										.map(function(item) {
											item.price = item.price
													.toFixed(0);
											return item;
										}));
						returnMinPrices = returnMinPrices
								.concat(response.returnMinPrices
										.map(function(item) {
											item.price = item.price
													.toFixed(0);
											return item;
										}));
						depMinMaxPrice= minMax(departureMinPrices);
						retMinMaxPrice=minMax(returnMinPrices);
					}
				}
			})
		.then(function() {
			if (departureMinPrices){
				fillCalendar(dpInstant);
			}

		});

	}
	else {
		setTimeout(function() {
			fillCalendar(dpInstant);
		}, 30);
	}
}

function minMax(items) {
    return items.reduce(function(res, val){
        res[0] = ( res[0] === undefined || parseInt(val.price) < res[0] ) ? val.price : res[0]
        res[1] = ( res[1] === undefined || parseInt(val.price) > res[1] ) ? val.price : res[1]
        return res;
    }, []);
}

function fillCalendar(dpInstant) {

	var isDeparture = dpInstant.id == 'departureDate';
	var arr = isDeparture ? departureMinPrices : returnMinPrices;
	var minMax= isDeparture ? depMinMaxPrice : retMinMaxPrice;
	var cls='';
	var curr= '';

	$(' .ui-datepicker td > *').each(function(idx, elem) {
		var compareDate = new Date(dpInstant.drawYear,
				dpInstant.drawMonth, idx + 1);
		var value = arr.find(function(obj) {
			return new Date(obj.date).getTime() == compareDate
					.getTime();
		});
		if (value) {
            if(curr=='') curr= getCurrencyIcon(value.currency);
			$(this).attr('data-content', curr+value.price);
			$(this).attr('Title','Min : ' + value.price + ' ' + value.currency);
			//MinMaxAvarage
			if(minMax){
				if(minMax[0]!=minMax[1]) {
				  cls='';
				  if(minMax[0]==parseInt(value.price)) {cls='pricemin';}
				  else if(minMax[1]==parseInt(value.price)) {cls='pricemax';}
				  else cls='';

				  if(cls!=''){ $(this).addClass(cls)};
				}
			}
		}
	});
}


function validateAndSetupParameters(start, end, fromAirportId, toAirportId, isDepartureInstant, isRoundTrip) {
	
	if (isNullOrEmpty(fromAirportId) || isNullOrEmpty(toAirportId)){
		return false;
	}
	if (typeof start === 'undefined' || start == null){
		return false;
	}

    if (isDepartureInstant){
        requestParams.departureStart = start;
        requestParams.departureEnd = end;
    }
    if (!isDepartureInstant && isRoundTrip){
        requestParams.departureStart = start;
        requestParams.departureEnd = end;
        requestParams.returnStart = start;
        requestParams.returnEnd = end;
	}
    else {
        requestParams.returnStart = start;
        requestParams.returnEnd = end;
    }

    if(requestParams.departureStart == null || requestParams.departureEnd == null){
    	return false;
	}


	if (!isRoundTrip){
		requestParams.returnStart = null;
		requestParams.returnEnd = null;
	}

    if (requestParams.fromAirportId != fromAirportId || requestParams.toAirportId != toAirportId || requestParams.isRoundTrip != isRoundTrip){
		requestParams.isRoundTrip = isRoundTrip;
		requestParams.fromAirportId = fromAirportId;
		requestParams.toAirportId = toAirportId;
		requestParams.searchMinDate = start;
		requestParams.searchMaxDate = end;
		departureMinPrices = [];
		returnMinPrices = [];
		return true;
	}
	else {
    	if (requestParams.searchMinDate.getTime() <= start.getTime() && requestParams.searchMaxDate >= end.getTime()){
    		return false;
		}
		else {
			requestParams.searchMinDate = requestParams.searchMinDate.getTime() >= start.getTime() ? start : requestParams.searchMinDate;
            requestParams.searchMaxDate = requestParams.searchMaxDate.getTime() <= end.getTime() ? end : requestParams.searchMaxDate;
            return true;
		}

	}




}

function getCurrencyIcon(cur){
    if(typeof cur !=='undefined' && typeof siteCurrencies[cur]!=='undefined') {
        var res= siteCurrencies[cur];
        if (typeof res!=='undefined' ) return res;
    }

}
